import React from 'react'
import styles from './select-school.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../../wrapper/wrapper'
import Container from '../../../../../container/container'
import Description from '../../../../../description/description'
import duck from '../../../../../images/su-duck.gif'
import SchoolSearch from './search/search.container'
import SchoolsList from './schools-list/schools-list.container'
import Footer from '../../../../../footer/footer'
import Spinner from 'pobble-components/dist/spinner'
import BackButton from '../../../../../back-button/back-button'
import { useMe } from 'pobble-components/dist/pobble-user'
import { apiSetRoleInLife } from '../../../../../../common/api/profile'
import { errorHandler } from 'pobble-components/dist/error-handler'
import Button from 'pobble-components/dist/button'
import { useRegisterTeacher } from '../helpers'

const SelectSchool = ({
  classes,
  showSchoolNotInTheList,
  onShowNewSchool,
  searchPending,
  selectedSchool
}) => {
  const { refetchMe } = useMe()
  const { registerTeacher, pending } = useRegisterTeacher()
  return (
    <Wrapper>
      <Container primary img={duck}>
        <Description title="Find your school">
          <p>
            Note: your account will be verified
            <br />
            with your school admin.
          </p>
          <BackButton
            bottomMargin
            onClick={() => {
              apiSetRoleInLife({
                role_in_life: null
              })
                .then(refetchMe)
                .catch(errorHandler)
            }}>
            Back to role selection
          </BackButton>
          <SchoolSearch className={classes.search} />
        </Description>
        <div className={classes.result}>
          {searchPending && (
            <div className={classes.pendingOverlay}>
              <Spinner />
            </div>
          )}
          <SchoolsList />
        </div>
        {showSchoolNotInTheList && (
          <Footer className={classes.footer}>
            <div className={classes.buttonHolder}>
              <Button
                className="metrics__fsu-as-teacher"
                action={() => registerTeacher(selectedSchool)}
                pending={pending}
                disabled={!selectedSchool}
                tall
                wide>
                Join the school
              </Button>
            </div>
            <Button
              simple
              wide
              className="metrics__school-not-in-list"
              action={onShowNewSchool}>
              My school is not in this list
            </Button>
          </Footer>
        )}
      </Container>
    </Wrapper>
  )
}

export default injectSheet(styles)(SelectSchool)
